import { getChannelAPIPath } from '@treasury/core/http';
import { AchFilterServices } from '@treasury/domain/channel/services/ach/ach-filter-services.js';

ArpService.$inject = ['$resource'];

export default function ArpService($resource) {
    return {
        searchArpExceptions,
        updateArpExceptions,
        getAchExceptionFilters,
        searchAchExceptionFilters,
        searchArpOutputFiles,
        getAchExceptions,
        searchAchExceptions,
        findAchExceptions,
        findAchExceptionsDecisionsActivity,
        saveAchExceptions,
        updateAchExceptions,
        getSecCodes,
        getSavedFormats,
        getSavedFormat,
        updateSavedFormat,
        deleteSavedFormat,
        parseIssuedItems,
        saveIssuedItems,
        searchIssuedItems,
        getArpAccounts,
        getAchExceptionsCutOffTimes,
    };

    function searchArpExceptions(filter) {
        return $resource(
            `${getChannelAPIPath()}arp/arpExceptions`,
            {},
            { search: { method: 'POST', isArray: false } }
        ).search(filter).$promise;
    }

    function updateArpExceptions(arpExceptions) {
        return $resource(`${getChannelAPIPath()}arp/`).save(arpExceptions).$promise;
    }

    function getAchExceptionFilters() {
        return $resource(`${getChannelAPIPath()}arp/achExceptionFilters`).query().$promise;
    }

    function searchAchExceptionFilters(filter) {
        return $resource(
            `${getChannelAPIPath()}arp/achExceptionFilters`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(filter).$promise;
    }

    function searchArpOutputFiles(filter) {
        return $resource(
            `${getChannelAPIPath()}arp/arpOutputFiles`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(filter).$promise;
    }

    function getAchExceptions() {
        return $resource(`${getChannelAPIPath()}arp/achExceptions`).query().$promise;
    }

    function searchAchExceptions(filter) {
        return $resource(
            `${getChannelAPIPath()}arp/searchAchExceptions`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(filter).$promise;
    }

    async function findAchExceptions(filter) {
        return AchFilterServices.findAchExceptions(filter);
    }

    function findAchExceptionsDecisionsActivity(searchModel) {
        return $resource(
            `${getChannelAPIPath()}arp/findAchExceptionsDecisionsActivity`,
            {},
            { search: { method: 'POST' } }
        ).search(searchModel).$promise;
    }

    function saveAchExceptions(achExceptions) {
        return $resource(`${getChannelAPIPath()}arp/saveAchExceptions`).save(achExceptions)
            .$promise;
    }

    function updateAchExceptions(achExceptions) {
        return $resource(`${getChannelAPIPath()}arp/achExceptions`).save(achExceptions).$promise;
    }

    function getSecCodes() {
        return $resource(`${getChannelAPIPath()}arp/secCodes`).query().$promise;
    }

    function getSavedFormats() {
        return $resource(`${getChannelAPIPath()}arp/savedFormats`).query().$promise;
    }

    function getSavedFormat(id) {
        return $resource(`${getChannelAPIPath()}arp/savedFormat`, { id }).get().$promise;
    }

    function updateSavedFormat(savedFormat) {
        return $resource(`${getChannelAPIPath()}arp/savedFormat`).save(savedFormat).$promise;
    }

    function deleteSavedFormat(id) {
        return $resource(`${getChannelAPIPath()}arp/deleteSavedFormat/:id`).delete({ id }).$promise;
    }

    function saveIssuedItems(issuedItems, fileName) {
        const arpModel = { account: null, issuedItems, issuedFileName: fileName };
        return $resource(
            `${getChannelAPIPath()}arp/saveIssuedItems`,
            {},
            {
                save: {
                    method: 'POST',
                    isArray: true,
                },
            }
        ).save(arpModel).$promise;
    }

    function parseIssuedItems(formatId, arpData) {
        return $resource(
            `${getChannelAPIPath()}arp/parseIssuedItems`,
            {},
            {
                save: {
                    method: 'POST',
                    transformRequest: tranformParseIssuedItemsRequest,
                    headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' },
                },
            }
        ).save({ formatId, arpData }).$promise;
    }

    function searchIssuedItems(filter) {
        return $resource(
            `${getChannelAPIPath()}arp/searchIssuedItems`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(filter).$promise;
    }

    function tranformParseIssuedItemsRequest(data) {
        const fd = new FormData();
        fd.append('formatId', data.formatId);
        fd.append('arpData', data.arpData);
        return fd;
    }

    function getArpAccounts(claimType) {
        return $resource(`${getChannelAPIPath()}arp/GetArpAccounts/:claimType`, {
            claimType,
        }).query().$promise;
    }

    function getAchExceptionsCutOffTimes() {
        return $resource(
            `${getChannelAPIPath()}arp/achExceptionsCutOffTimes`,
            {},
            { get: { method: 'GET', isArray: false } }
        ).get().$promise;
    }
}
